/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { ReadCreditLineStatusResponse } from '../services/avc-credit-line-status.model';

export enum ActionTypes {

  RequestCreditLineStatus = '[AVCCREDITLINE] request credit line status',
  RequestCreditLineStatusSuccess = '[AVCCREDITLINE] credit line status received successfully',
  RequestCreditLineStatusError = '[AVCCREDITLINE] request credit line status - error',
}

export class RequestCreditLineStatus implements Action {
  readonly type = ActionTypes.RequestCreditLineStatus;
  constructor() {}
}

export class RequestCreditLineStatusSuccess implements Action {
  readonly type = ActionTypes.RequestCreditLineStatusSuccess;
  constructor(public avcCreditLine: ReadCreditLineStatusResponse) {}
}

export class RequestCreditLineStatusError implements Action {
  readonly type = ActionTypes.RequestCreditLineStatusError;
  constructor(public payload: any) {}
}

export type Actions =
  RequestCreditLineStatus
  | RequestCreditLineStatusSuccess
  | RequestCreditLineStatusError;
